import React, { Fragment } from 'react';
import RadioButton from "../../../RadioButton";

// Format time string like "09:00:00" → "9 AM" / "17:00:00" → "5 PM"
const formatHour = (timeStr) => {
  if (!timeStr) return '';
  const [h] = timeStr.split(':').map(Number);
  if (isNaN(h)) return timeStr;
  const period = h >= 12 ? 'PM' : 'AM';
  const hour = h % 12 || 12;
  return `${hour} ${period}`;
};

export default function WeekDay(props) {
  const { day, setWeekday, weekday, itemLabel, dayData, addWeekDay } = props;
  const startLabel = formatHour(dayData?.start);
  const endLabel = formatHour(dayData?.end);
  const hasHours = startLabel && endLabel;

  return (
    <Fragment key={`radio-${day}`}>
      <RadioButton
        classes="weekDays"
        uniqId={`userInfoTab-${day}`}
        onChangeHandle={setWeekday}
        size="md"
        activeValue={weekday}
        value={day}
      >
        <span className="weekDay__label">{itemLabel}</span>
        {hasHours && (
          <span
            className="weekDay__hours"
            onClick={(e) => {
              e.stopPropagation();
              addWeekDay('edit', {
                dayName: day,
                availabilityTime: [{ [itemLabel]: [dayData] }],
              });
            }}
            title={`${startLabel}–${endLabel} · click to edit`}
          >
            ✎
          </span>
        )}

      </RadioButton>
    </Fragment>
  );
}
